"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allDescriptors = void 0;
const ValidationErrors_1 = require("../../components/ValidationErrors");
const validation_1 = require("./validation");
exports.allDescriptors = {
    string: ({ restrictions, validateByValues } = {}) => ({
        toInput: (x) => x !== null && x !== void 0 ? x : '',
        toValue: (x) => x,
        onEvent: (e) => e.target.value,
        restrictions,
        validateByValues,
    }),
    ['boolean']: ({ restrictions, validateByValues } = {}) => ({
        toInput: (x) => x !== null && x !== void 0 ? x : false,
        toValue: (x) => x,
        onEvent: (e) => ('checked' in e.target) && e.target.checked,
        restrictions,
        validateByValues,
    }),
    number: ({ restrictions, validateByValues } = {}) => ({
        toInput: (x) => { var _a; return (_a = x === null || x === void 0 ? void 0 : x.toString(10)) !== null && _a !== void 0 ? _a : ''; },
        toValue: (x) => {
            if (!(0, validation_1.hasNotEmptyValue)(x))
                return undefined;
            if (!(0, validation_1.hasNumberValue)(x))
                return undefined;
            const v = Number(x);
            return v;
        },
        onEvent: (e) => e.target.value,
        validateInput: (x) => {
            if (!(0, validation_1.hasNotEmptyValue)(x))
                return undefined;
            if (!(0, validation_1.hasNumberValue)(x)) {
                return [ValidationErrors_1.messageById['schema/type/number'].text(undefined)];
            }
            return undefined;
        },
        restrictions,
        validateByValues,
    }),
    object: ({ restrictions, validateByValues } = {}) => ({
        toInput: (x) => x,
        toValue: (x) => x,
        onEvent: (x) => x,
        restrictions,
        validateByValues,
    }),
};
//# sourceMappingURL=allDescriptors.js.map